import css from './sass/style.scss';

require('./js/polyfills.js');
require('./js/carousels.js');
require('./js/counter.js');
require('./js/fonts.js');
require('./js/helpers.js');
require('./js/init.js');
require('./js/ismobile.js');
require('./js/map.js');
require('./js/nav.js');
require('./js/validate.js');
require('./js/video.js');
require('./js/scroll.js');
require('./js/cars.js');
require('./js/cookie-msg.js');

//require('./js/inview.js');
//require('./js/fixel.js');
//require('./js/scrollpos.js');
//require('./js/scrollprogress.js');

//require('./js/mobile-detach.js');



require('./img/icons/location--green.svg');
require('./img/icons/location--red.svg');
require('./img/photos/slider-01.jpg');
require('./img/photos/slider-01b.jpg');
require('./img/photos/slider-01b-mobile.jpg');
require('./img/photos/slider-02.jpg');
require('./img/photos/slider-03.jpg');
require('./img/photos/slider-04.jpg');
require('./img/photos/slider-04a.jpg');
require('./img/photos/slider-04a-mobile.jpg');
require('./img/photos/slider-05.jpg');
require('./img/photos/slider-05a.jpg');
require('./img/photos/slider-06.jpg');
require('./img/photos/top.jpg');
require('./img/photos/top@2x.jpg')
require('./img/photos/01.jpg');
require('./img/photos/01@2x.jpg');
require('./img/photos/02.jpg');
require('./img/photos/02@2x.jpg');
require('./img/photos/video.jpg');
require('./img/photos/video@2x.jpg');
require('./img/favicon.png');

require('./img/photos/finances/01.jpg');
require('./img/photos/finances/02.jpg');
require('./img/photos/finances/03.jpg');

require('./img/photos/offer-04a.jpg');
require('./img/photos/slider-01a.jpg');
require('./img/photos/slider-01a-mobile.jpg');

require('./img/photos/sla01a.jpg');
require('./img/photos/sla02a.jpg');
require('./img/assets/logo-wilanow-toyota.svg');
require('./img/assets/logo-plock.svg');
